module.exports = __webpack_public_path__ + "img/unknown.fb50fc64.svg";